export default __webpack_public_path__ + "static/media/tunning_banner_p3.f4cc39dd.png";